// extracted by mini-css-extract-plugin
module.exports = {"Container":"ProfileLayout_Container__tRdOB","SideMenu":"ProfileLayout_SideMenu__3nWtl","Content":"ProfileLayout_Content__1YN3y"};